import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { PageHeader, StatusBadge } from "@/components/Common";
import { api, formatErr, fmtDate, useFetch } from "@/lib/api";

const PLANS = ["starter", "growth", "enterprise"];

export default function AdminMembers() {
  const { data, setData } = useFetch("/admin/members");

  const update = async (u, status, plan) => {
    try {
      const { data: nu } = await api.patch(`/admin/members/${u.id}/membership`, { status, plan });
      setData((p) => p.map((x) => (x.id === u.id ? nu : x)));
      toast.success("Membership updated");
    } catch (e) { toast.error(formatErr(e)); }
  };

  return (
    <div>
      <PageHeader eyebrow="Accounts" title="Members" desc="Business owners registered on the platform and their membership status." />
      <div className="overflow-x-auto rounded-md border border-stone-200 bg-white">
        <table className="w-full min-w-[760px] text-sm">
          <thead className="bg-stone-50 text-left text-[11px] font-mono uppercase tracking-wider text-stone-500">
            <tr><th className="px-5 py-3">Business</th><th className="px-5 py-3">Contact</th><th className="px-5 py-3">Joined</th><th className="px-5 py-3">Plan</th><th className="px-5 py-3">Status</th><th className="px-5 py-3">Active</th></tr>
          </thead>
          <tbody className="divide-y divide-stone-100">
            {(data || []).map((u) => {
              const m = u.membership || {};
              const on = m.status === "active";
              return (
                <tr key={u.id} data-testid={`member-row-${u.id}`}>
                  <td className="px-5 py-3 font-medium text-stone-900"><Link to={`/admin/businesses/${u.id}`} className="hover:underline" data-testid={`member-view-${u.id}`}>{u.company || "—"}</Link></td>
                  <td className="px-5 py-3"><p>{u.name}</p><p className="text-xs text-stone-500">{u.email}</p></td>
                  <td className="px-5 py-3 text-xs text-stone-500">{fmtDate(u.created_at)}</td>
                  <td className="px-5 py-3">
                    <Select value={m.plan || "none"} onValueChange={(v) => update(u, m.status || "inactive", v === "none" ? null : v)}>
                      <SelectTrigger data-testid={`member-plan-${u.id}`} className="w-36 capitalize"><SelectValue /></SelectTrigger>
                      <SelectContent><SelectItem value="none">None</SelectItem>{PLANS.map((p) => <SelectItem key={p} value={p} className="capitalize">{p}</SelectItem>)}</SelectContent>
                    </Select>
                  </td>
                  <td className="px-5 py-3"><StatusBadge status={m.status || "inactive"} /></td>
                  <td className="px-5 py-3"><Switch data-testid={`member-active-${u.id}`} checked={on} onCheckedChange={(v) => update(u, v ? "active" : "inactive", m.plan || "starter")} /></td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {data?.length === 0 && <p className="p-6 text-sm text-stone-500">No members yet.</p>}
      </div>
    </div>
  );
}
